var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.071 14.142a1.25 1.25 0 010 1.768L16.697 28.284a1.25 1.25 0 11-1.768-1.767l12.374-12.375a1.25 1.25 0 011.768 0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.929 14.142a1.25 1.25 0 011.768 0L29.07 26.517a1.25 1.25 0 11-1.768 1.767L14.93 15.91a1.25 1.25 0 010-1.768z",
    fill: "#fff"
  })));
}

export default SvgStatusClose;